export enum WorkflowActions {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}
